// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__367Ub","red":"Title_red__1Fkm6","light":"Title_light__ODEmG","dark":"Title_dark__2uDgY"};